import React from 'react'
import { Navigate } from 'react-router-dom'

export const RedirectAdminInvestorLogin = () => <Navigate to='/admin/client-login' replace />

export const RedirectFirstTimeInvestor = () => <Navigate to='/first-time-client' replace />
